// ======================================================================
// File Name       : AuthorityDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Form, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import $ from 'jquery';
import BackButton from '../../components/BackButton';
import AuthorityDetail from '../../components/authority/AuthorityDetail';
import DialogConfirm from '../../components/DialogConfirm';
import { getAuthorityList, authorityEdit } from '../../actions/AuthorityAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { AUTHORITY, AUTHORITY_LIST } from '../../constants/PathConstants';
import { MODE, SELECT_TARGET_DATA } from '../../constants/index';
import { MANAGEMENT_AUTHORITY_DISPLAY_TYPE, USER_AUTHORITY_ROLE } from '../../constants/AuthorityConstant';
import { AUTHORITY_EDIT } from '../../constants/FunctionConstants';
import { canAccess } from '../../utils/AuthedUtils';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class AuthorityDetailContainer extends React.Component {
  /**
     * Constructor function of component
     */
  constructor(props) {
    super(props);
    this.state = {
      showDeleteConfirmModal: false,
      authority: null,
    };
    this.onDeleteAuthorityCancel = this.onDeleteAuthorityCancel.bind(this);
    this.onDeleteAuthorityOk = this.onDeleteAuthorityOk.bind(this);
    this.openDeleteConfirmDialog = this.openDeleteConfirmDialog.bind(this);
  }

  /**
     * Life cycle function of component
     */
  componentWillMount() {
    const { authority, match, history } = this.props;
    const { authorityInfo } = authority;
    if (authorityInfo.managementAuthorityList.length === 0) {
      //  Back to authority top
      history.push(AUTHORITY_LIST);
    } else {
      const authorityDetails = $.grep(
        authorityInfo.managementAuthorityList,
        e => e.managementAuthoritySecernId === match.params.id,
      );
      if (authorityDetails.length > 0) {
        // Step 10.0.0 START
        const { managementFunctionAuthorityInfo } = authorityDetails[0];
        const authorityDisplayMapping = Object.keys(managementFunctionAuthorityInfo).reduce((acc, cur) => {
          acc[`${cur}Display`] = managementFunctionAuthorityInfo[cur] > 0
            ? MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
            : MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;
          return acc;
        }, {});

        authorityDetails[0].managementFunctionAuthorityDisplayInfo = {
          ...authorityDisplayMapping,
        }
        // Step 10.0.0 END
        this.setState({
          authority: authorityDetails[0],
        });
      }
    }
  }

  /**
   * Life cycle function
   */
  componentWillReceiveProps(nextProps) {
    const { authority, match } = nextProps;
    const { authorityInfo } = authority;
    const authorityDetails = $.grep(
      authorityInfo.managementAuthorityList,
      e => e.managementAuthoritySecernId === match.params.id,
    );
    if (authorityDetails.length > 0) {
      this.setState({
        authority: authorityDetails[0],
      });
    }
  }

  /**
     * Show delete authority confirm dialog
     * @param {*} mdContent
     * @param {*} mdSize
     */
  openDeleteConfirmDialog() {
    this.content = MessageTemplate.MSG_DEL_AUTHORITY;
    this.setState({ showDeleteConfirmModal: true });
  }

  /**
     * Event button cancel of delete confirm dialog clicked
     */
  onDeleteAuthorityCancel() {
    this.setState({ showDeleteConfirmModal: false });
  }

  /**
     * Event button ok of delete confirm dialog clicked
     */
  onDeleteAuthorityOk() {
    this.setState({ showDeleteConfirmModal: false });
    const param = {
      editType: MODE.DELETE_MODE,
      managementAuthorityInfo: {
        managementAuthoritySecernId: this.state.authority.managementAuthoritySecernId,
      },
    };
    const { history } = this.props;
    this.props.dispatch(authorityEdit(param)).then(() => {
      // go to authority top
      history.push(AUTHORITY_LIST);
    });
  }

  /**
     * Render function of component
     */
  render() {
    const authorityInfo = this.state.authority;
    const editPath = authorityInfo
      ? `/${AUTHORITY}/${authorityInfo.managementAuthoritySecernId}/edit`
      : '';
    let showButton = false;
    if (
      authorityInfo &&
      authorityInfo.managementAuthoritySecernId !== USER_AUTHORITY_ROLE.ADMIN &&
      authorityInfo.managementAuthoritySecernId !== USER_AUTHORITY_ROLE.TEACHER &&
      authorityInfo.managementAuthoritySecernId !== USER_AUTHORITY_ROLE.SCORING_MANAGEMENT &&
      authorityInfo.managementAuthoritySecernId !== USER_AUTHORITY_ROLE.HISTORY_VIEWING // Step 10.0.0
    ) {
      showButton = canAccess(AUTHORITY_EDIT);
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.AUTHORITY_LIST}
          text="ロール一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ロールの詳細" />
        {authorityInfo && <AuthorityDetail authority={authorityInfo} />}
        <Form className='form-horizontal'>
          <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="text-center">
              {showButton &&
                <Link className="btn btn-primary margin-10 btn-96" role="button" to={editPath}>
                  編集
                </Link>}
              {showButton &&
                <Button
                  variant="primary"
                  className="btn-96 margin-10"
                  onClick={this.openDeleteConfirmDialog}
                >
                  削除
                </Button>}
            </Col>
          </Form.Group>
        </Form>
        <DialogConfirm
          showModal={this.state.showDeleteConfirmModal}
          onCancel={this.onDeleteAuthorityCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteAuthorityOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ authority: state.authority },
});

export default connect(mapStateToProps)(AuthorityDetailContainer);
